/**
 * One row of a setup checklist.
 *
 * Deliberately presentational: `id` is a plain string so each app can key it
 * off its own step enum without the shared component depending on either one.
 */
export interface SetupStep {
  id: string;
  label: string;
  iconName: string;
  completed: boolean;
  /** True when prerequisites are unmet and the step cannot be started yet. */
  locked?: boolean;
  /** Shown beneath the label to explain why a locked step is unavailable. */
  lockedHint?: string;
  /**
   * Whether selecting this step swaps the checklist for the detail template.
   * Defaults to true. Set false for steps that navigate away instead, so the
   * card never renders a detail view the caller has nothing to put in.
   */
  opensDetail?: boolean;
}
